import { Repository } from "../../adapters/repository";
import { present } from "../../../utils/presenter";
import { Interactor } from "./types";

function createInteractor(repository: Repository): Interactor {
  return ({ project, weatherReport }) =>
    present(
      repository
        .updateProjectWeatherReport(project, weatherReport)
        .then(() => ({ project, weatherReport }))
        .catch(() => Promise.reject({ project, weatherReport })),
    );
}

export type { Interactor };

export { createInteractor };
